"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _CustomPropertiesListField = _interopRequireDefault(require("./CustomPropertiesListField"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomPropertiesEditCtx = _ref => {
  let {
    ctx,
    customPropertiesEndpoint,
    id,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    nameOverride
  } = _ref;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);

  // Deal with all the possible label override options
  const getAccordionLabel = () => {
    // Special case for null context
    if (ctx === 'isNull') {
      return kintIntl.formatKintMessage({
        id: 'customProperties',
        overrideValue: labelOverrides.noContext
      });
    }

    // Chain formatKintMessages together using provided fallbackMessage to
    // allow for "If override or translation exists, use it, else use default"
    return kintIntl.formatKintMessage({
      id: `customProperties.ctx.${ctx}`,
      overrideValue: labelOverrides[ctx],
      fallbackMessage: kintIntl.formatKintMessage({
        id: 'customProperties.defaultTitle',
        overrideValue: labelOverrides.defaultTitle
      }, {
        ctx
      })
    }, {
      ctx
    });
  };
  const {
    data: custprops,
    isLoading
  } = (0, _hooks.useCustomProperties)({
    ctx,
    endpoint: customPropertiesEndpoint,
    returnQueryObject: true,
    options: {
      filters: [{
        path: 'retired',
        comparator: '!=',
        value: 'true'
      }]
    }
  });
  if (isLoading) {
    return null;
  }
  return custprops.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Accordion, {
    id: `${id}-accordion-${ctx}`,
    label: getAccordionLabel(),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomPropertiesListField.default, {
      ctx: ctx,
      customProperties: custprops,
      intlKey: passedIntlKey,
      intlNS: passedIntlNS,
      labelOverrides: labelOverrides,
      name: nameOverride ?? 'customProperties'
    })
  });
};
CustomPropertiesEditCtx.propTypes = {
  ctx: _propTypes.default.string,
  customPropertiesEndpoint: _propTypes.default.string,
  id: _propTypes.default.string,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  nameOverride: _propTypes.default.string
};
var _default = exports.default = CustomPropertiesEditCtx;